import { Header, type IHeaderProps } from '@procurify/ui'

import { ConversationTextStyled } from './styles/ConversationTextStyled'

export type ConversationTextVariant = NonNullable<IHeaderProps['as']>

export interface IConversationTextProps {
  variant: ConversationTextVariant
  content: string
}

export const ConversationText = ({
  variant,
  content,
}: IConversationTextProps) => (
  <ConversationTextStyled>
    <Header as={variant}>{content}</Header>
  </ConversationTextStyled>
)
